import PropTypes from 'prop-types'

import { CloseButton } from '@loadsmart/loadsmart-ui'

import { Header } from './Bid.styles'

export function BidHeader({ title, onClose }) {
  return (
    <Header>
      {title}
      <CloseButton title="close bid dialog" onClick={onClose} />
    </Header>
  )
}

BidHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}
